// auth.guard.ts
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { UnespCoreMessageService } from 'src/libs/unesp-core'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(
    private authService: AuthService,
    private router: Router,
    private messageService: UnespCoreMessageService
  ) {}

  async canActivate(): Promise<boolean> {
    if (this.authService.isLoggedIn) {
      return true
    }

    // Token expirado mas refresh token disponível — tenta renovar
    if (this.authService.getRefreshToken) {
      try {
        await this.authService.refreshTokenAndGetNew()
        return true
      } catch {
        // Refresh token também expirou — limpa sessão local e mostra tela de login
        this.authService.logoutLocal()
        this.router.navigate(['/'])
        this.messageService.showMessageWarning(
          'Sua sessão expirou. Por favor, faça login novamente.',
          'Fechar',
          10000
        )
        return false
      }
    }

    this.router.navigate(['/'])
    return false
  }
}
